<template>
	<div class="fixed z-20 bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
		<div class="fixed inset-0 transition-opacity">
			<div class="absolute inset-0 bg-gray-900 opacity-75"></div>
		</div>
	<div class="max-w-4xl mx-auto py-6 sm:px-6 lg:px-8 z-10">
		<!-- Replace with your content -->

		<div class="bg-white p-4 rounded-lg shadow-xl ">
			<div class="flex justify-between">
				<h3 class="font-googleBold mb-2">Add New Slide to Repository</h3>
				<svg @click="$emit('close')" class="w-6 h-6 cursor-pointer" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
			</div>
			<p class="text-sm mb-3 text-gray-500">Copy a full slide from Google Slides and paste anywhere to be saved. Save and attach a thumbnail of the slide, include a title, optional description, add tags, and assign the slide to a collection before hitting "Add"!</p>
			<div class="grid grid-cols-1 gap-6">
				<div class="relative">
					<div
						class="border border-gray-300 rounded-lg shadow-sm focus-within:border-indigo-500 focus-within:ring-1 focus-within:ring-indigo-500">
						<input type="text" name="title" id="title"
							   class="block w-full border-0 pt-2.5 text-lg font-medium bg-transparent placeholder-gray-500 focus:ring-0"
							   v-model="form.slideTitle"
							   placeholder="Slide Title"/>
						<textarea rows="3" name="description" id="description"
								  v-model="form.description"
								  class="block w-full border-0 py-0 resize-none placeholder-gray-500 focus:ring-0 sm:text-sm"
								  placeholder="Add a description or notes for later..."/>


						<div class="">

							<div class="flex justify-end py-2 px-2 space-x-2 sm:px-3">

								<div v-for="(selectedTag,index) in selectedTags" :key=index
									 class="relative inline-flex items-center rounded-full py-2 px-2 bg-gray-50 text-sm font-medium text-gray-500 whitespace-nowrap hover:bg-gray-100 sm:px-3">
									<span class="text-gray-900">{{ selectedTag.name }}</span>
									<button @click="removeTag(selectedTag)">
										<svg xmlns="http://www.w3.org/2000/svg"
											 class="flex-shrink-0 h-5 w-5 ml-1 text-gray-300" viewBox="0 0 20 20"
											 fill="currentColor">
											<path fill-rule="evenodd"
												  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
												  clip-rule="evenodd"/>
										</svg>
									</button>

								</div>


								<!-- Add Tag dropdown -->
								<div class="relative sm:inline-block text-left ">


									<button @click="tagDropdownOpen = !tagDropdownOpen" type="button"
											class="relative inline-flex items-center rounded-full py-2 px-2 bg-gray-50 text-sm font-medium text-gray-500 whitespace-nowrap hover:bg-gray-100 sm:px-3">
										<svg xmlns="http://www.w3.org/2000/svg" class="flex-shrink-0 h-5 w-5 sm:-ml-1 mr-1 text-gray-300" viewBox="0 0 20 20" fill="currentColor">
											<path fill-rule="evenodd" d="M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
										</svg>
										<span class="text-gray-900">Add Tag</span>
									</button>


									<!--Full width button to close if you click outside-->
									<button v-if="tagDropdownOpen" @click="tagDropdownOpen = false"
											tabindex="-1" class="fixed inset-0 h-full w-full cursor-default"></button>

									<transition enter-active-class="transition ease-out duration-100"
												enter-from-class="transform opacity-0 scale-95"
												enter-to-class="transform opacity-100 scale-100"
												leave-active-class="transition ease-in duration-75"
												leave-class="transform opacity-100 scale-100"
												leave-to-class="transform opacity-0 scale-95">

										<div v-if="tagDropdownOpen"
											 class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg z-10">
											<div class="rounded-md bg-white shadow-xs">
												<div class="py-1">

													<div class="flex mr-2 h-[36px]">
														<input type="text" name="title" id="labelname"
															   class="block w-full border-0 text-sm font-medium placeholder-gray-500 focus:ring-0"
															   placeholder="Add new tag..."
															   v-model="newTagEntry"
															   @keydown.space.stop
															   @keydown.enter.prevent="addTag()"
														/>
														<button v-if="newTagEntry.length > 0" @click="addTag()" class="border border-gray-300 hover:bg-gray-100 hover:cursor-pointer m-1 p-2 rounded shadow">
															<svg class="h-3 fill-gray-600" viewBox="-148.269 -27.249 512 377.175" xmlns="http://www.w3.org/2000/svg"><path d="M310.1313-27.249v184.975h-355.2l96.1-98.4-37.8-38.6-161.5 164.6 161.5 164.6 37.8-38.6-96.1-98.4h408.8V-27.249z"/></svg>
														</button>
													</div>

													<button v-for="(tag,index) in tags" :key=index
															@click="selectTag(tag)"
															:class="[true ? 'cursor-pointer text-gray-700' : 'cursor-not-allowed text-gray-500']"
															class="inline-flex relative block px-4 py-2 text-sm leading-5  text-left w-full hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900">
														{{tag.name}}
													</button>

												</div>
											</div>
										</div>
									</transition>
								</div>



							</div>
							<div
								class="border-t border-gray-200 px-2 py-2 flex justify-between items-center space-x-3 sm:px-3">
								<div class="flex">
									<Listbox as="div" v-model="selectedCollection" class="flex-shrink-0">
										<ListboxLabel class="sr-only"> Collection </ListboxLabel>
										<div class="relative">
											<ListboxButton class="relative inline-flex items-center rounded-full py-2 px-2 bg-gray-50 text-sm font-medium text-gray-500 whitespace-nowrap hover:bg-gray-100 sm:px-3">
												<svg :class="[selectedCollection.value === null ? 'text-gray-300' : 'text-gray-500', 'flex-shrink-0 h-5 w-5 sm:-ml-1']" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
													<path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" />
												</svg>
												<span :class="[selectedCollection.value === null ? '' : 'text-gray-900', 'hidden truncate sm:ml-2 sm:block']">{{ selectedCollection.value === null ? 'Collection' : selectedCollection.name }}</span>
											</ListboxButton>

											<transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
												<ListboxOptions class="absolute z-10 mt-1 w-52 bg-white shadow max-h-56 rounded-lg py-3 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
													<ListboxOption as="template" v-for="collection in props.collections" :key="collection.short_name" :value=collection v-slot="{ active,selected }">
														<li :class="[active ? 'bg-gray-100' : 'bg-white', 'cursor-default select-none relative py-2 px-3']">
															<div class="flex items-center">
																<span class="block font-medium truncate">
																	{{ collection.name }} <span class="bg-gray-100 rounded-xl m-2 text-xs py-1 px-2 text-gray-800">{{collection.slides_count}}</span>
																</span>
																<span
																	v-if="selected"
																	class="absolute inset-y-0 right-0 flex items-center pr-3">
																	<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
																		<path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
																	</svg>
																</span>
															</div>
														</li>
													</ListboxOption>
												</ListboxOptions>
											</transition>
										</div>
									</Listbox>

									<div v-if="doesClipboardContainGoogleElement" class="flex items-center">
										<img src="/storage/gslides_logo.svg" class="drop-shadow-md h-8 ml-3 p-px">
										<div class="flex ml-2">
											<div class="flex-shrink-0">
												<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
													<path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
												</svg>
											</div>
											<div class="ml-2">
												<h3 v-if="!thumbnailUploadDone" class="text-sm font-medium text-green-800">Google Slide detected and added! Awaiting thumbnail...</h3>
												<h3 v-else class="text-sm font-medium text-green-800">Google Slide and thumbnail added successfully!</h3>

											</div>
										</div>
									</div>
									<div v-if="doesClipboardContainPptxElement" class="flex items-center">
										<img src="/storage/pptx_logo.svg" class="drop-shadow-md h-8 ml-3 p-px">
										<div class="flex ml-2">
											<div class="flex-shrink-0">
												<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
													<path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
												</svg>
											</div>
											<div class="ml-2">
												<h3 class="text-sm font-medium text-green-800">PowerPoint slide and thumbnail added successfully!</h3>

											</div>
										</div>
									</div>

								</div>
								<div class="flex-shrink-0">
									<button @click="submit()"
											class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white w-24 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
											:class="[(hasPasted && (doesClipboardContainGoogleElement || doesClipboardContainPptxElement) && thumbnailUploadDone && form.slideTitle.length>0) ? 'bg-indigo-600 hover:bg-indigo-700' : 'bg-gray-200 cursor-not-allowed hover:bg-gray-300']"
											:disabled="(!(hasPasted && (doesClipboardContainGoogleElement || doesClipboardContainPptxElement) && thumbnailUploadDone && form.slideTitle.length>0)) || form.processing"
									>
										<span v-if="!form.processing">
											Add Slide
										</span>
										<span v-else class="mx-auto">
											<svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
												<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
												<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
											</svg>
										</span>
									</button>
								</div>
							</div>
						</div>



					</div>


				</div>

				<!-- Form warning -->
				<div class="rounded-lg bg-red-50 p-4 self-center" v-if="Object.keys($page.props.errors).length > 0">
					<div class="flex" >
						<div class="flex-shrink-0">
							<svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
								<path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
							</svg>
						</div>
						<div class="ml-3">
							<h3 class="text-sm font-medium text-red-800">Looks like something went wrong. Mind trying again? This error was logged in the meantime.</h3>
						</div>
					</div>
				</div>


				<div class="overflow-hidden border-gray-300 rounded-lg h-[450px]"
					 :class="[doesClipboardContainPptxElement || thumbnailUploadDone ? 'border ' : 'border-2 border-dashed']">

					<div v-if="!hasPasted || (!doesClipboardContainGoogleElement && !doesClipboardContainPptxElement)" class="flex h-full items-center">
						<div class="w-full">
							<img class="h-64 mx-auto mb-5" src="/storage/copy_preview.png">
							<div v-if="!hasPasted" class="text-center px-8">Copy your slide from the sidebar of Google Slides and paste anywhere using <span class="font-mono">Ctrl + V</span>.</div>

							<div v-if="hasPasted && !doesClipboardContainGoogleElement && !doesClipboardContainPptxElement" class="rounded-lg bg-red-50 mx-8 p-4 self-center">
								<div class="flex">
									<div class="flex-shrink-0">
										<svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
											<path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
										</svg>
									</div>
									<div class="ml-3">
										<h3 class="text-sm font-medium text-red-800">Looks like your clipboard doesn't contain a Google Slide. Try copy and pasting again?</h3>
									</div>
								</div>
							</div>

							<div class="flex items-center mt-4 animate-pulse justify-center">
								<div class="bg-gray-100 border border-gray-400 p-4 rounded-xl text-center text-gray-800 shadow w-20">Ctrl</div>
								<div class="px-3 text-center text-gray-800 text-2xl">+</div>
								<div class="bg-gray-100 border border-gray-400 p-4 rounded-xl text-center text-gray-800 shadow w-16">V</div>
							</div>
						</div>

					</div>


					<div v-if="form.previewImageURL.length > 0" class="relative">
						<img :src="form.previewImageURL">
						<svg xmlns="http://www.w3.org/2000/svg" class="absolute bottom-0 h-6 m-2 right-0 text-gray-500 hover:text-red-400 hover:cursor-pointer w-6 z-30" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
							 @click="handleThumbnailDelete()">
							<path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
						</svg>
					</div>

					<!--							<input type="file" name="image" @input="form.previewImage = $event.target.files[0] && submit($event.target.files[0])" ref="file" :hidden="!(hasPasted && doesClipboardContainGoogleElement)"/>-->


					<label v-if="hasPasted && doesClipboardContainGoogleElement" class="block relative overflow-hidden rounded w-full h-full"
						   @dragover="dragging=true" @drop="dragging=false" @dragleave="dragging=false">

						<input
							type="file"
							name="image"
							ref="fileUpload"
							accept="image/*"
							class="absolute top-0 left-0 right-0 bottom-0 w-full block m-1 cursor-pointer"

							@input="handleUpload($event.target.files[0])"
						/>
						<!-- This is where we do the fancy styling with Tailwind CSS and transform this thing from a normal file input to a nicely styled drag and drop dropzone-->

						<!-- The pointer-events-none class here is very important as it allows our drags and clicks to pass through to the input underneath -->
						<span
							class="absolute top-0 left-0 right-0 bottom-0 w-full block text-gray-800 pointer-events-none cursor-pointer flex items-center justify-center"
							:class="[dragging ? 'bg-gray-100' : 'bg-white']"
						>

							<div v-if="!thumbnailUploadDone">
								<div class="rounded-md bg-blue-50 p-4 m-4">
									<div class="flex">
										<div class="flex-shrink-0">
											<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
												<path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
											</svg>
										</div>
										<div class="ml-3">
											<h3 class="text-sm font-medium text-blue-800"><span
												class="font-bold">Last step: </span> please upload a thumbnail/ screenshot of the slide.
											</h3>

										</div>
									</div>
								</div>

								<div class="space-y-4 text-center cursor-pointer">
									<svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
										<path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
									<div class="text-gray-600">
										<p class="pl-1"><span class="font-black">Click to upload</span> or drag and drop</p>
									</div>
									<p class="text-xs text-gray-500 mt-4">On a Mac? Use <span class="font-mono font-black">Shift + Command + 4</span></p>
									<p class="text-xs text-gray-500 mt-2">On Windows? Use <span class="font-mono font-black">Shift + Windows Key + S</span></p>
								</div>
							</div>
						</span>
					</label>
				</div>
			</div>
		</div>
	</div>



		<!-- /End replace -->



	</div>



</template>

<script setup>
import {computed, reactive, ref, onMounted} from "vue";


import {Link, useForm} from '@inertiajs/vue3'

import { Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions } from '@headlessui/vue'

const props = defineProps({
	open: {type: Boolean, default: false},
	collections: {type: Object, default: {"name":"Personal","short_name":"personal","slides_count":0} },
	activeCollection: {type: Object },
	tags: Object
});

onMounted(() => {
	if(Object.keys(props.tags).length > 0) {
		tags.value = props.tags;
	}
});

const form = useForm({
	slideTitle: '',
	description: '',
	collection: '',
	clipboard: [],
	tags: [],
	previewImageURL: '',
	previewImage: null
});

let tags = ref([
	{ name: 'Summary', short_name: 'summary' },
	{ name: 'Data', short_name: 'data' },
	{ name: 'Charts', short_name: 'charts' },
	{ name: 'Text-Based', short_name: 'text-based' },
	{ name: 'Pictorial', short_name: 'pictorial' }
]);

let selectedTags = ref([]);
const newTagEntry = ref('');

function selectTag(tag) {
	tags.value = tags.value.filter((el) => { return el.short_name !== tag.short_name})
	selectedTags.value.push(tag);
}

function removeTag(tag) {
	selectedTags.value = selectedTags.value.filter((el) => { return el.short_name !== tag.short_name})
	tags.value.push(tag);
}

function addTag() {

	let tag = newTagEntry.value;

	let titleCase = tag.toLowerCase().split(' ').map(function(word) {
		return (word.charAt(0).toUpperCase() + word.slice(1));
	}).join(' ');
	let kebabCase = tag
		.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
		.map(x => x.toLowerCase())
		.join('-');

	let newTag = { name: titleCase, short_name: kebabCase };

	selectedTags.value.push(newTag);
	newTagEntry.value = '';
	tagDropdownOpen.value = false;

}

function handleUpload(event) {

	thumbnailUploadDone.value = true;
	// const file = event.target.files[0];
	form.previewImage = event
	form.previewImageURL = URL.createObjectURL(event)
}

const fileUpload = ref();

function handleThumbnailDelete() {

	fileUpload.value = null;
	form.previewImageURL = '';
	thumbnailUploadDone.value = false;
	if(doesClipboardContainPptxElement.value) {
		console.log(doesClipboardContainPptxElement)
		// also clear clipboard and hasPasted
		// console.log("clear other stuff now...")
		form.clipboard = [];
		hasPasted.value = false;

	}

}



const selectedCollection = ref(props.activeCollection)

const tagDropdownOpen = ref(false)

const hasPasted = ref(false);
const thumbnailUploadDone = ref(false);
const dragging = ref(false);

const doesClipboardContainGoogleElement = computed(() => {

	let output = form.clipboard.filter(el => el.type.includes("application/x-vnd.google"));
	return output.length > 0;
})

const doesClipboardContainPptxElement = computed(() => {
	let output = form.clipboard.filter(el => el.type.includes("ppt/slides"));
	return output.length > 0;
});

document.addEventListener('paste', function(e){

	// check if I should be intercepting this or not
	hasPasted.value = true;

	const output = extractData(e.clipboardData)
		.then((response) => {

			if (response.files.length > 0) {
				form.previewImageURL = response.files[0].url
				// form.previewImage = response.files[0]

			}
			// this.$refs.file = response.files[0]
			console.log(form.previewImageURL)

			return response
		})

	output.then((r) => {

		form.clipboard = r.types
		// this won't be defined when uploading a GSlides ... this is what allows the form to pick up the image!

		// console.log("---trying to see what raw file looks like---");
		// console.log(r.files[0].rawFile);
		form.previewImage =  r.files[0].rawFile
		// console.log("---done with raw file---");


		if (r.types.filter(el => el.type.includes("ppt/slides")).length > 0) {
			// console.log("---upload done via pptx paste--");
			thumbnailUploadDone.value = true;
		}

		// console.log(form.clipboard)
	});


});


async function extractData(data) {

	if (!data) {
		return undefined;
	}

	const file_info = file =>
		file
			? {
				name: file.name,
				size: file.size,
				type: file.type,
				url: URL.createObjectURL(file),
				rawFile: file
			}
			: null;

	if (data instanceof DataTransfer) {
		return {
			type: 'DataTransfer',
			types: Array.from(data.types).map(type => ({
				type,
				data: data.getData(type)
			})),
			items: data.items
				? Array.from(data.items).map(item => ({
					kind: item.kind,
					type: item.type,
					as_file: file_info(item.getAsFile())
				}))
				: null,
			files: data.files ? Array.from(data.files).map(file_info) : null
		};
	}

	if (data instanceof ClipboardItem) {
		return {
			type: 'ClipboardItem',
			types: await Promise.all(
				Array.from(data.types).map(async type => {
					const blob = await data.getType(type);
					return {
						type: type,
						data: blob.type.match(/^text\//)
							? await blob.text()
							: file_info(blob),
					};
				})
			)
		};
	}
	return undefined;
}


const clipboard = ref([]);
const emit = defineEmits(['close']);

function submit() {

	form
		.transform((data) => ({
			...data,
			// clipboard: [result.types],
			tags: selectedTags.value,
			collection: selectedCollection.value

			// previewImage: result.files[0].rawFile
		}))
		.post('/repository', {
			forceFormData: true,
			onSuccess: () => {
				emit('close');
				// alert("posted!");
			}
		});


}




</script>
